import { render, staticRenderFns } from "./ProcessListScenarios.vue?vue&type=template&id=480ca103&scoped=true&"
import script from "./ProcessListScenarios.vue?vue&type=script&lang=js&"
export * from "./ProcessListScenarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ca103",
  null
  
)

export default component.exports